import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { createTheme, MantineProvider } from '@mantine/core';
import { configureAxiosClient } from './api/axios-client';
import Sidebar from './sidebar/sidebar';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import './index.css';

configureAxiosClient(axios);
const theme = createTheme({});

const loadAndRenderApp = async (loader: Promise<any>) => {
  let { default: App } = await loader;
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <MantineProvider theme={theme}>
      <App />
    </MantineProvider>
  );
};

let path = window.location.pathname;

if (
  path.match(/^\/admin\//g) != null &&
  path.match(/^\/admin\/login\//g) == null
) {
  // show menu and sidebar in admin pages
  const sidebarRoot = document.getElementById('branding');
  if (sidebarRoot) {
    const root = ReactDOM.createRoot(sidebarRoot);
    root.render(
      <MantineProvider theme={theme}>
        <Sidebar />
      </MantineProvider>
    );
  }
  // fix zIndex on filters
  let filters = document.getElementById('changelist-filter');
  if (filters) filters.style.zIndex = '150';
} else if (path.startsWith('/pb/')) {
  (async function () {
    let { default: App } = (await import('./postbuy/PostbuyApp')) as any;
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(<App />);
  })();
} else if (path.startsWith('/pb_ch/')) {
  (async function () {
    let { default: App } = (await import('./postbuy_ch/PostbuyChApp')) as any;
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(<App />);
  })();
} else if (path === '/ui/admin-actions/prepare-invoice/') {
  loadAndRenderApp(import('./apps/admin-actions/PrepareInvoiceApp'));
} else if (path === '/ui/admin-actions/adjust-period') {
  loadAndRenderApp(import('./apps/admin-actions/AdjustPeriodApp'));
} else if (path === '/ui/admin-actions/create-eracun') {
  loadAndRenderApp(import('./apps/admin-actions/CreateEracunApp'));
} else if (path === '/ui/photoplan') {
  loadAndRenderApp(import('./apps/postbuy-photo-plan/App'));
} else if (path === '/ui/postbuy-admin') {
  loadAndRenderApp(import('./apps/postbuy-admin/postbuy-admin'));
} else if (path.startsWith('/ui/')) {
  // newer codebase is in App.tsx

  (async function loadAndRender() {
    let { default: App } = await import('./App');
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(<App />);
  })();
}
